import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-bloc-contact-fiserv',
  templateUrl: './bloc-contact-fiserv.component.html',
  styleUrls: ['./bloc-contact-fiserv.component.scss'],
  standalone: false,
})
export class BlocContactFiservComponent implements OnInit {
  numeroTelephone: string;

  constructor(private readonly translateService: TranslateService) {}

  ngOnInit() {
    this.translateService.get('caad.modifier-fiserv.lienTexteBlocContact').subscribe((libelle: string) => {
      this.numeroTelephone = 'tel:' + libelle.replace(/[\s-]/g, '');
    });
  }
}
